import { AnyRoute, createRoute, redirect } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

import BankCompaniesWrapper from './BankCompaniesWrapper'
import { companiesListRoute } from './Routes/CompaniesList/route'
import { contactAddRoute, contactEditRoute, detailsRoute } from './Routes/CompanyDetails/route'
import { createCompanyRoute, editCompanyRoute } from './Routes/ManageCompany/route'

export const routeCompaniesTree = <T extends AnyRoute>(rootRoute: T) => {
  const companiesIndexRoute = createRoute({
    beforeLoad: async ({ context }) => {
      if (!context.accessibleRoutingFlags.companyRootAccess) {
        if (context.accessibleRoutingFlags.onboardingRootAccess) {
          throw redirect({
            to: '/onboarding/applications'
          })
        } else
          throw redirect({
            to: routes.bank.settings
          })
      }
    },
    getParentRoute: () => rootRoute,
    path: routes.bank.relationships.index,
    component: BankCompaniesWrapper
  })

  return companiesIndexRoute.addChildren([
    createCompanyRoute<typeof companiesIndexRoute>(companiesIndexRoute),
    editCompanyRoute<typeof companiesIndexRoute>(companiesIndexRoute),
    contactEditRoute<typeof companiesIndexRoute>(companiesIndexRoute),
    contactAddRoute<typeof companiesIndexRoute>(companiesIndexRoute),
    detailsRoute<typeof companiesIndexRoute>(companiesIndexRoute),
    companiesListRoute<typeof companiesIndexRoute>(companiesIndexRoute)
  ])
}
